import React, { useState } from "react";
import axios from "axios";

function AdminUploadForm() {
    // State variables
    const [productTypes, setProductTypes] = useState([
        "wheat beer",
        "rice beer",
        "soft drink",
    ]); // Example product types
    const [selectedProductType, setSelectedProductType] = useState("");
    const [batchId, setBatchId] = useState("");
    const [certificateFile, setCertificateFile] = useState(null);

    // Handler for file input
    const handleFileChange = (event) => {
        setCertificateFile(event.target.files[0]);
    };

    // Handler for form submission
    const handleSubmit = async (event) => {
        event.preventDefault();
        console.log("Form submitted");

        if (!selectedProductType || !batchId || !certificateFile) {
            alert("Please fill in all fields.");
            return;
        }

        const formData = new FormData();
        formData.append("productType", selectedProductType);
        formData.append("batchId", batchId);
        formData.append("certificate", certificateFile);

        try {
            // Make an API call to your upload endpoint
            const response = await axios.post("/upload_certificate", formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            });

            if (response.status === 200) {
                alert("Certificate uploaded successfully!");
            } else {
                alert("Failed to upload the certificate.");
            }
        } catch (error) {
            console.error("Error uploading the certificate:", error);
            alert("An error occurred while uploading the certificate.");
        }
    };

    return (
        <div className="max-w-lg mx-auto p-6 bg-white shadow-lg rounded-lg">
            <h2 className="text-xl font-bold mb-4">Upload Certificate</h2>
            <form onSubmit={handleSubmit}>
                {/* Dropdown for product type */}
                <div className="mb-4">
                    <label htmlFor="productType" className="block mb-2 font-medium">
                        Product Type:
                    </label>
                    <select
                        id="productType"
                        className="w-full border border-gray-300 rounded p-2"
                        value={selectedProductType}
                        onChange={(e) => setSelectedProductType(e.target.value)}
                        required
                    >
                        <option value="">Select a product type</option>
                        <option value="" disabled>
                            Select a beverage type
                        </option>
                        <option value="rice beer">Rice Beer</option>
                        <option value="wheat beer">Wheat Beer</option>
                        <optgroup label="Soft Drinks">
                            <option value="pineapple tepache">Pineapple Tepache</option>
                            <option value="coconut water">Fermanted Coconut water</option>
                        </optgroup>
                    </select>
                </div>

                {/* Input for batch ID */}
                <div className="mb-4">
                    <label htmlFor="batchId" className="block mb-2 font-medium">
                        Batch ID:
                    </label>
                    <input
                        type="text"
                        id="batchId"
                        className="w-full border border-gray-300 rounded p-2"
                        value={batchId}
                        onChange={(e) => setBatchId(e.target.value)}
                        placeholder="Enter new batch ID"
                        required
                    />
                </div>

                {/* File upload for certificate */}
                <div className="mb-4">
                    <label htmlFor="certificate" className="block mb-2 font-medium">
                        Upload Certificate (PDF):
                    </label>
                    <input
                        type="file"
                        id="certificate"
                        className="w-full border border-gray-300 rounded p-2"
                        accept=".pdf"
                        onChange={handleFileChange}
                        required
                    />
                </div>

                {/* Submit button */}
                <button
                    type="submit"
                    className="w-full bg-blue-600 text-white py-2 rounded hover:bg-blue-700"
                >
                    Upload Certificate
                </button>
            </form>
        </div>
    );
}

export default AdminUploadForm;
